module.exports = __webpack_public_path__ + "static/media/favicon-32x32.fe47c715.svg";